<nav class="navbar custom-navbar main-footer small px-3">
  <ul class="navbar-nav me-auto">
    <li class="nav-item">
      <a class="nav-link text-color" id="footer-copyright-link" href="javascript:;">
        <span>Copyright &copy; 2025</span> <span class="text-uppercase"> Seam Labs</span>. All rights reserved
      </a>
    </li>
  </ul>

</nav>
